var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionThermometer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 13a5 5 0 1 1-7.906 3.029L7.1 16A5 5 0 0 1 9 13V5a3 3 0 1 1 6 0v8Zm-4 .999-.799.6c-.47.354-.832.84-1.03 1.401h5.659a3.005 3.005 0 0 0-1.031-1.401l-.799-.6V5a1 1 0 1 0-2 0v1h1v2h-1v2h1v2h-1v1.999Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionThermometer);
export default __webpack_public_path__ + "static/media/ic_action_thermometer.db735b5d738c04c738d5aabef459faa7.svg";
export { ForwardRef as ReactComponent };